<template>
  <div class="pso">
    <step-status :step="$route.meta.step" class="mt55"></step-status>

    <h1 class="guide">
      Congratulations on passing your final interview with our Recruitment Team! <br />
      To learn more about our HAWO Group Class training program, please watch the videos below:
    </h1>
    <div class="video">
      <!-- <h4><span>2.Watch a video</span></h4> -->
      <!-- <p class="video_tit">Please review the video as it contains helpful information about 51Talk.</p> -->
      <div class="video_cont">
        <video @play="playVideoHandler" :src="urls.psoVideoLink" controls="controls"></video>
      </div>
    </div>
    <div class="pso_tip">
      <p>We hope you were able to get a better understanding of the basics of Group Class, the training path, and the expectations we have for this training.</p>
      <p>
        Please make sure to check your email or Skype for the next step/s in the process. Your recruiter will be reaching out to you via those channels.<br />
        You may also add the HAWO Recruitment Skype: live:.cid.9d7dbebba05d49b9 for faster coordination.
        <!-- Here’s the link for all the training modules and AirClass(AC) that you need to complete and download:<br />
        
        Training Modules: <a :href="urls.trainingModulesLink" target="_blank">{{urls.trainingModulesLink}}</a><br />

        Install AirClass Link (for Windows): <a :href="_acDownloadUrl.pc" target="_blank" v-if="_acDownloadUrl.pc">{{_acDownloadUrl.pc}}</a><br />

        AirClass for MAC: App Store > Search “51TALK AirClass” > Download -->
      </p>
    </div>
    <div class="next_cont">
      <a class="button" @click="nextHandler" :class="{cancel: !videoIsPlay}" href="javascript:;">Next</a>
    </div>
    <!-- Google pixel -->
    <div style="display:inline;">
      <img height="1" width="1" style="border-style:none;" alt="" src="//www.googleadservices.com/pagead/conversion/852175291/?label=uP-SCPvDsngQu9OslgM&amp;guid=ON&amp;script=0" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { urls } from '@js'

export default {
  props: {},
  data() {
    return {
      videoIsPlay: false,
      urls
    }
  },
  computed: {
    ...mapGetters(['_acDownloadUrl'])
  },
  methods: {
    playVideoHandler() {
      this.videoIsPlay = true
    },

    nextHandler() {
      if (!this.videoIsPlay) return
      const loading = this.$loading()
      this.$http
        .get('/Personal/psoNext')
        .then(d => {
          loading.close()
          if (d.data.code == '75000') {
            let state = d.data.res.next
            switch (state) {
              case 'fillform': // 填写表单页面
                this.$router.replace('/fillform')
                break

              case 'interview': //interview页面
                this.$router.replace('/book_interview')
                break

              case 'pso': //pso页面
                this.$router.replace('/pso')
                break

              case 'tpg': //tpg页面
                this.$router.replace('/book_tpg')
                break

              case 'onboarding': // 个人信息页面
                this.$router.replace('/personal_profile/personal_qa')
                break

              case 'updatepwd': //修改密码页面
                this.$router.replace('/resetcode')
                break
              case 'end': //流程结束
                this.$router.replace('/get_started')
                break
              default:
                //均不匹配
                console.log('pso 匹配 error.')
            }
          } else {
            this.$message.error(d.data.message)
          }
        })
        .catch(err => {
          loading.close()
          this.$message.error('server error')
        })
    }
  }
}
</script>

<style lang='less' scoped>
.pso {
  width: 1000px;
  padding-bottom: 130px;
  margin: 0 auto;
  img {
    margin-top: 55px;
  }
  .guide {
    margin-top: 50px;
    font-size: 18px;
    line-height: 1.4;
  }
  .video_tit {
    font-size: 16px;
    color: #525252;
    line-height: 19px;
    margin-bottom: 20px;
    text-indent: 30px;
  }
  .video {
    margin: 40px 0 60px 0;
    .video_cont {
      text-align: center;
    }

    video {
      width: 100%;
    }
  }
  .pso_tip {
    margin-bottom: 60px;
    line-height: 1.5;

    p {
      margin-bottom: 20px;
    }

    a {
      text-decoration: underline;
      color: #009cff;
    }
  }
  .next_cont {
    height: 46px;
    text-align: center;
    margin-top: 20px;
    a {
      width: 337px;
      height: 46px;
      text-align: center;
      line-height: 46px;
      border: none;
      border-radius: 10px;
      font-size: 24px;
      color: #fff;
      background-color: #ccc;
      display: inline-block;
      &.button {
        color: #1e1e1e;
        background-color: #fcc800;
      }
      &.cancel {
        background: #cccccc;
        color: #fff;
        cursor: default;
      }
    }
  }

  .hide {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// pso.vue?ed94db66